import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import TestimonialCarousel from './ui/TestimonialCarousel';

// --- IMPORTAÇÃO DAS IMAGENS DE DEPOIMENTO ---
// Ajuste os caminhos conforme sua estrutura de pastas (ex: '../assets/')
import Foto1 from '../assets/testemunho_1_foto.jpeg'; // [cite: 5]
import Texto1 from '../assets/testemuno_1_texto.jpeg'; // [cite: 6]

import Foto2 from '../assets/testemunho_2_foto.jpeg'; // [cite: 7]
import Texto2 from '../assets/testemunho_2_texto.jpeg'; // [cite: 8]

import Foto3 from '../assets/testemunho_3_foto.jpeg'; // [cite: 9]
import Texto3 from '../assets/testemunho_3_texto.jpeg'; // [cite: 10]

// Criando a estrutura de dados para o carrossel
const testimonialData = [
  {
    photo: Foto1,
    text: Texto1
  },
  {
    photo: Foto2,
    text: Texto2
  },
  {
    photo: Foto3,
    text: Texto3
  }
];

const TestimonialsSection = () => (
  <Box id="depoimentos" sx={{ bgcolor: 'background.paper', py: 8 }}>
    <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
      
      <Typography variant="h3" color="primary" gutterBottom>
        O QUE DIZEM MEUS ALUNOS
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 6 }}>
        Resultados reais de quem confiou no processo.
      </Typography>

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        {/* Usando o novo componente dedicado */}
        <TestimonialCarousel items={testimonialData} />
      </Box>

    </Container>
  </Box>
);

export default TestimonialsSection;